function UppercaseIntialFilter() {
  return function (str) {
    if (!str) return str;

    const newStr = `${str[0].toUpperCase()}${str.substring(1, str.length).toLowerCase()}`;

    return newStr;
  };
}

UppercaseIntialFilter.$inject = [];

export default UppercaseIntialFilter;



// WEBPACK FOOTER //
// ./src/filters/uppercaseIntial.js